import { useEffect } from 'react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'

/**
 * Applies a magnetic pointer-offset transform to ref.current.
 * @param {React.RefObject} ref
 * @param {number} strength - multiplier for the offset (default 0.28)
 */
export function useMagnetic(ref, strength = 0.28) {
    const reducedMotion = usePrefersReducedMotion()

    useEffect(() => {
        const el = ref.current
        if (!el) return

        const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches
        if (isTouch || reducedMotion) return

        const onMove = (e) => {
            const r = el.getBoundingClientRect()
            const cx = r.left + r.width / 2
            const cy = r.top + r.height / 2
            el.style.transform = `translate3d(${(e.clientX - cx) * strength}px, ${(e.clientY - cy) * strength}px, 0)`
        }
        const onLeave = () => { el.style.transform = '' }

        el.addEventListener('mousemove', onMove)
        el.addEventListener('mouseleave', onLeave)

        return () => {
            el.removeEventListener('mousemove', onMove)
            el.removeEventListener('mouseleave', onLeave)
            el.style.transform = ''
        }
    }, [ref, strength, reducedMotion])
}
